import { useFetch, usePost } from '@/core/hooks/useFetch';
import { ApiResource } from '@future-harry/nxt-styles';
import { JobItem, AvailableFilter, SearchFilters } from '@/modules/content-blocks/interfaces/jobs-block.interface';
import { POSITIONS_ENDPOINTS } from './positions.endpoints';

export async function getFilters(tenantId: number) {
   try {
      const response = await useFetch<ApiResource<{ filter_elements: AvailableFilter[] }>>(
         `${POSITIONS_ENDPOINTS.GET_FILTERS()}?tenant_id=${tenantId}`,
      );

      return response.data.value?.data ?? { filter_elements: [] };
   } catch (error) {
      return { filter_elements: [] };
   }
}

export function searchJobs(
   searchFilters: SearchFilters,
   jobBoardUrl: string,
   tenantId: number,
   jobBoardId: number,
   page: number = 1,
   perPage: number = 25,
) {
   const fullDomainUrl = `https://${jobBoardUrl.trim()}.nxtpeople.jobs`;

   return usePost<ApiResource<JobItem[]>>(`${POSITIONS_ENDPOINTS.SEARCH_JOBS()}?url=${fullDomainUrl}&tenant_id=${tenantId}`, {
      data: {
         ...searchFilters,
         aggregations: ['cities', 'job_types', 'work_schedules'],
         job_board_id: jobBoardId,
         page,
         per_page: perPage,
      },
   });
}
